import { defineNuxtPlugin } from '#imports';
import { updateScreenSize } from '~/composables/use-screen-size';

export default defineNuxtPlugin((nuxtApp) => {
  // Watch and handle media queries on client.

  nuxtApp.hook('app:mounted', () => {
    updateScreenSize();
    window.addEventListener('resize', () => {
      updateScreenSize();
    });
  });
});
